module.exports = __webpack_public_path__ + "img/c-thermometer-img4-2.ab5e1252.png";